import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const storage =
  "https://firebasestorage.googleapis.com/v0/b/aristocrat-inn.appspot.com/o";
const cloudinaryUrl = "https://api.cloudinary.com/v1_1/teamtigers/auto/upload";
const emailSenderApi = "https://aristocrat-api.herokuapp.com/api/data";
const successResponse = "Submitted successfully. We will get back to you soon.";
const errorResponse = "Something went wrong";
const successColor = "blue darken-3";
const errorColor = "red";

export default new Vuex.Store({
  state: {
    navbarMenu: [
      { route: "/", routeName: "Home" },
      { route: "rooms", routeName: "Rooms" },
      { route: "restaurant", routeName: "Restaurant" },
      { route: "conference", routeName: "Conference" },
      { route: "booking", routeName: "Booking" },
      { route: "contact", routeName: "Contact" },
      { route: "career", routeName: "Career" }
    ],
    vectors: [
      {
        id: "spark",
        source: `${storage}/spark.svg?alt=media&token=ea2a925b-b5b9-4435-b77f-904ff94281fb`
      },
      {
        id: "block",
        source: `${storage}/block.svg?alt=media&token=4a8a9965-57cc-48e3-9b52-22711ab2f06d`
      },
      {
        id: "ellipse",
        source: `${storage}/ellipse.svg?alt=media&token=9dc1c7ed-8d9e-476e-8e83-6a503772b42a`
      }
    ],
    constant: {
      miniEllipse: `${storage}/Ellipse%20292.svg?alt=media&token=e2c27e2e-35f8-4f0a-91fc-1d19d2350920`,
      bigEllipse: `${storage}/Group%2018.svg?alt=media&token=6e67ac67-8d90-4886-83bd-d187e571c124`,
      cleanEllipse: `${storage}/Ellipse%20293.svg?alt=media&token=305889b4-b2ce-442e-adec-99ae57d0419f`,
      offerImage: `${storage}/Group%2015.svg?alt=media&token=388b5efa-ff5c-4d61-8de0-1f5d07eb1473`,
      checkCircle: `${storage}/check-circle.svg?alt=media&token=d2c4a8e9-ebf7-4304-9189-7a8974f7d0a2`,
      offers: [
        "Complimentary buffet breakfast.",
        "Free WIFI in every room speed up to 50 mbps (unlimited).",
        "Free newspaper, welcome drinks & fruit basket on arrival.",
        "Airport Pickup.",
        "<span>Airport protocol service (Immigration, Customes, On arrival Visa, Luggage clearance etc.)</span>",
        "24 hrs. Business Center/ secretarial services.",
        "Concierge service"
      ]
    },
    heroImages: {
      home: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      rooms: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      restaurant: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      conference: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      booking: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      contact: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      career: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
    },
    homeHeroSectionTitles: [
      {
        text: "Welcome to",
        style: "primary-font header-title-small font-weight-medium"
      },
      {
        text: "Hotel Aristocrat Inn",
        style: "tertiary-font header-title-big primary--text"
      },
      {
        text:
          "Excellent hotel in the most secured zone of Dhaka surrounded by all embassies & International clubs in the heart of diplomatic zone, Gulshan 2, Dhaka, Bangladesh",
        style: "quaternary-font font-weight-light",
        margin: "mt-5"
      },
      {
        text: "For Booking: a_inn@hotmail.com",
        style: "quaternary-font font-weight-medium",
        margin: "mt-4"
      },
      {
        text: "Contact: +880 1817019200, +8802 222281014",
        style: "quaternary-font font-weight-medium",
        margin: "mt-1"
      }
    ],
    homeBrandingCards: [
      {
        title: "Free wifi",
        image: `${storage}/wifi.svg?alt=media&token=75e84d41-f549-485b-be41-07d8a77473ea`
      },
      {
        title: "Airport Pickup",
        image: `${storage}/car.svg?alt=media&token=1973d198-6ffd-4c87-9a4c-4c745d9f78a9`
      },
      {
        title: "Buffet Breakfast",
        image: `${storage}/buffet.svg?alt=media&token=274c444d-ba33-4eb4-9b0d-843cc4ec390b`
      },
      {
        title: "Fruit Basket",
        image: `${storage}/basket.svg?alt=media&token=058c1aca-b0e8-4e77-82ee-56b2680de8ab`
      }
    ],
    services: [
      {
        showHeader: true,
        title: "Atmosphere Restaurant",
        subTitle:
          "We serve a wide variety of food. You will get foods like Continental, Chinese, Thai, Italian, Indian & Bangladeshi cuisine at our restaurant.",
        showMiniEllipse: true,
        image: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
        routeLink: "/restaurant"
      },
      {
        isExchnaged: true,
        title: "Conference & Royal Banquet",
        subTitle:
          "Our Conference hall is well equipped with Projector, Multimedia, Sound system and other logistic supports. We setup round table, board room, U shape, Class room and theater style. We also do Family get-together, all kind of parties or any other occasions and events.",
        showBigEllipseWithSpark: true,
        image: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
        routeLink: "/conference"
      },
      {
        title: "Lobby & Balcony",
        subTitle:
          "This is one of the special attraction of our hotel. Our lobby is very spacious and followed by a balcony in each floor. Where you can have your small meeting and relax during your leisure time",
        showBigEllipse: true,
        image: `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
      }
    ],
    footerTexts: {
      title: "Hotel Aristrocart Inn",
      address: "House # 12, Road #68, 68A, Gulshan-2, Dhaka-1212, Bangladesh",
      communication: `Tel: +8802 222281014, +8802 222292327 <br /> Cell:+880-1817019200, +880-1924304304, +880-1732279155 <br /> Email: a_inn@hotmail.com`,
      copyright: `©${new Date().getFullYear()} — Hotel Aristocrat Inn Ltd. All rights
      reserved`,
      facebook: `https://www.facebook.com/AristocratInn`
    },
    appHeroTexts: {
      rooms: {
        taglines: ["Choose Your Room", "Enjoy Your Stay"],
        subTitle:
          "Enjoy your stay in style with 5 different types of rooms to choose from Deluxe to Aristocrat Suit – with bird's eye view of the city greenery from few rooms. Each room is elegantly designed with luxury and comfort in mind."
      },
      restaurant: {
        taglines: ["Try Our Atmosphere", "Restaurant"],
        subTitle:
          "For good health it is required to have good food. We value your health, so we always try to serve the best food according to your need."
      },
      conference: {
        taglines: ["Try Our Digital Conference", "Room for Your Meeting"],
        subTitle:
          "Want to hold a meeting or throw a birthday party? Rest assured. We got you covered. We have well equipped digital supports for you with perfect setup."
      },
      booking: {
        taglines: ["Book Your Desired", "Room In Simple Steps"],
        subTitle:
          "We value your time and security. Please fill out the following form with care."
      },
      contact: {
        taglines: ["Contact with us. We are", "happy to help anytime"],
        subTitle:
          "We would be delighted to hear from you. Please send us a message and we will get back to you as soon as possible."
      },
      career: {
        taglines: ["Build your career", "at Aristocrat Inn"],
        subTitle:
          "We would be delighted to hear from you. Please send us a message and we will get back to you as soon as possible."
      }
    },
    rooms: [
      {
        photos: [
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
        ],
        title: "Deluxe",
        subtitle:
          "All Deluxe rooms have a large size bed. Other room amenities include Split Air Conditions, 32'' LCD TV, International channels, Mini Bar, Complimentary Wi-Fi connections, Intercom with Local/International dial and work desk.Complementary Breakfast (Continental/Indian), Complementary Flower, Fruit Basket, Welcome drinks on arrival, Free Newspaper"
      },
      {
        photos: [
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
        ],
        title: "Super Deluxe",
        subtitle:
          "All Super Deluxe rooms have a king size bed. Other room amenities include Split Air Conditions, 32'' LCD TV, International channels, Mini Bar,Complimentary Wi-Fi connections, Intercom with Local/International dial and work desk.Complementary Breakfast (Continental/Indian), Complementary Flower, Fruit Basket, Welcome drinks on arrival, Free Newspaper."
      },
      {
        photos: [
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
        ],
        title: "Aristocrat Deluxe",
        subtitle:
          "All Aristocrat Deluxe rooms have a large king size bed.Other room amenities include Split Air Conditions,32'' LCD TV, International channels, Mini Bar, Complimentary Wi-Fi connections,Intercom with Local/International dial an      d work desk. Complementary Breakfast (Continental/Indian) , Complementary Flower, Fruit Basket, Welcome drinks on arrival, Free Newspaper."
      },
      {
        photos: [
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
        ],
        title: "Aristocrat Deluxe (Twin)",
        subtitle:
          "All Aristocrat Deluxe (Twin) rooms have a large double king size bed. Other room amenities include Split Air Conditions, 32'' LCD TV, International channels, Mini Bar, Complimentary Wi-Fi connections, Intercom with Local/International dial and work desk. Complementary Breakfast (Continental/Indian), Complementary Flower, Fruit Basket, Welcome drinks on arrival, Free Newspaper"
      },
      {
        photos: [
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
          `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
        ],
        title: "Aristocrat Suit",
        subtitle:
          "All Aristocrat Suit rooms have a large king size bed and the other room have a cozy sitting arrangements with 32” LED TV. Other room amenities include Split Air Conditions, 32'' LED TV, International channels, Mini Bar, Complimentary Wi-Fi connections, Intercom with Local/International dial and work desk. Complementary Breakfast (Continental/Indian), Complementary Flower, Fruit Basket, Welcome drinks on arrival, Free Newspaper."
      }
    ],
    restaurantPhotos: [
      `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
    ],
    conferencePhotos: [
      `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`,
      `${storage}/hero-image.svg?alt=media&token=1dbd5382-a9d2-4e1f-a7dd-0872489b62d0`
    ],
    snackbarText: "",
    snackbarColor: ""
  },
  getters: {
    getHeroImage: state => source => state.heroImages[source],
    getConstant: state => source => state.constant[source],
    getAppHeroTexts: state => source => state.appHeroTexts[source]
  },
  mutations: {
    SHOW_MESSAGE_IN_SNACKBAR: (state, payload) => {
      state.snackbarText = payload.text;
      state.snackbarColor = payload.color;
    }
  },
  actions: {
    async uploadFile(context, payload) {
      const formData = new FormData();
      formData.append("file", payload);
      formData.append("upload_preset", "j7npnn8e");

      return await fetch(cloudinaryUrl, {
        method: "POST",
        body: formData
      })
        .then(response => response.json())
        .then(data => data)
        .catch(error => error);
    },
    async sendEmail(context, payload) {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: payload,
        redirect: "follow"
      };

      return await fetch(emailSenderApi, requestOptions)
        .then(response => response.json())
        .then(result => result)
        .catch(error => error);
    },
    showSuccessSnackBar({ commit }) {
      commit("SHOW_MESSAGE_IN_SNACKBAR", {
        text: successResponse,
        color: successColor
      });
    },
    showFailedSnackBar({ commit }) {
      commit("SHOW_MESSAGE_IN_SNACKBAR", {
        text: errorResponse,
        color: errorColor
      });
    }
  }
});
